import styled, { css, keyframes } from 'styled-components'

import Banner from './images/Banner-Mobile.svg'

const BannerContainer = styled.div`
  background-color: var(--Raven);
  background-image: url(${({Image}) => Image || 'https://djhonz7dexnot.cloudfront.net/9c7b7aec389c8cdddd49ff6b0a819db3033f8819.jpg'});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  display: inline-block;
  width: 100%;
  height: 575px;
  @media (max-width: 600px) {
    height: 12rem;
  }
  @media (min-width: 1750px) {
    height: 31%;
  }
`
const BannerMobileImg = styled.img`
  width: 100%;
  height: 12rem;
  position: absolute;
  top: 0;
  @media (min-width: 600px) {
    display: none;
  }
`
const Container = styled.div`
  width: 100%;
  background-color: var(--Dove);
  display: flex;
  flex-direction: column;
  align-items: center;
`
const BannerHeadingLogo = styled.div`
  font-size: 4.5rem;
  font-weight: bold;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: var(--Dove);
  display: inline-block;
  margin: 0.4em 0em;
  @media (max-width: 600px) {
    font-size: 3rem;
    z-index: 1;
    position: relative;
    width: 92%;
    margin: 0.4rem auto;
    display: block;
  }

  img {
    width: 178px;
    height: 44px;
  }
`
const BannerContent = styled.div`
  width: 72%;
  margin: 0em auto;
  color: var(--bg);
  font-size: 2.4rem;
  font-weight: 800;
  position: relative;
  @media (max-width: 600px) {
    width: 100%;
    margin: 0;
    min-height: 12rem;
  }
`
const BtnContainer = styled.div``
const EarnBtnContainer = styled.div`
  width: 100%;
  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -2rem;
    left: 0%;
  }
`
const BannerButton = styled.button`
  width: 422px;
  height: 86px;
  min-width: 160px;
  min-height: 60px;
  font-weight: 800;
  background-color: ${({ activeTabColor }) =>
    activeTabColor ? 'var(--azure)' : '#E5E5E5'};
  color: ${({ activeTabColor }) => (activeTabColor ? 'var(--bg)' : 'black')};
  font-size: 24px;
  border: none;
  text-align: center;
  cursor: pointer;
  text-transform: capitalize;
  margin: 32px 15px 32px 0;
  border-radius: 0.2rem;
  @media (max-width: 600px) {
    min-width: 130px;
    height: 60px;
    flex-grow: 0;
    margin: 5px 0 5px 0;
    font-size: 35%;
    text-transform: uppercase;
    align-items: center;
    font-weight: bold;
    border-radius: 2px;
  }
`
const Button = styled.button`
  font-weight: 800;
  background-color: var(--azure);
  font-size: 0.9rem;
  color: var(--bg);
  border: none;
  text-align: center;
  cursor: pointer;
  padding: 1.4rem 2.8rem;
  text-transform: capitalize;
  box-shadow: 0 8px 16px 0 #b5e0fd;
  border-radius: 2px;
  margin: 1rem 0rem;
`
const chevronArrowAnimation = keyframes`
  0% {
    transform: translateX(0px)
  }
  100% {
    transform: translateX(5px)
  }
`
const EarnButton = css`
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: capitalize;
  height: 64px;
  width: 100%;
  max-width: 360px;
  background-color: var(--azure-500);
  border-radius: 4px;
  font-size: 18px;
  font-weight: 800;
  color: var(--bg-alt);
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.text.textMuted16};
  -webkit-tap-highlight-color: transparent;
  margin: 0px auto;

  svg {
    margin-left: 16px;
    animation: ${chevronArrowAnimation} 0.25s linear infinite alternate;
  }
`
const EarnSectionButton = styled.button`
  ${EarnButton}
  margin: 0px;
  transition: all 0.2s;
  @media (max-width: 770px) {
    margin: 0px auto;
    width: 100%;
  }
`
const BannerHeadingContainer = styled.div`
  color: var(--bg-alt);
  @media (max-width: 600px) {
    background-color: var(--Dove);
    text-align: center;
    border-radius: 0.5rem;
    color: black;
    font-size: 1.4rem;
    min-width: 90%;
    padding: 0.8rem 0.2rem;
    box-shadow: 0 2px 4px 0 rgba(125, 125, 125, 0.35);
    z-index: 1;
    position: relative;
    width: 72%;
    margin: 9.2rem auto 1rem;
    /* transform: translateY(50%); */
  }
`

const BannerHeading = styled.h1`
  font-size: 3.5vw;
  color: var(--bg-alt);
  font-weight: 800;
  @media (max-width: 600px) {
    text-align: center;
    color: black;
    min-height: 30px;
    font-size: 4.2vw;
    min-width: 90%;
  }
`
const BannerSubHeading = styled.h3`
  font-size: 2.8vw;
  font-weight: 500;
  @media (max-width: 600px) {
    font-size: 4vw;
  }
`
const SectionsContainer = styled.div`
  width: 900px;
  border-radius: 8px;
  box-shadow: 6px 5px 18px 2px rgba(237, 235, 235, 0.35);
  background-color: var(--bg-alt);
  transform: ${(props) => props.transform && 'translateY(-130px)'};
  height: fit-content;
  padding-bottom: 60px;
  @media (max-width: 600px) {
    width: 100%;
  }
  /* @media (max-width: 768px) and (min-width: 600px) {
    width: 90%;
  } */
`
const SectionsCommonHeading = styled.h3`
  text-align: center;
  line-height: 2;
  font-weight: 600;
  color: var(--Text900);
  font-size: 1.6rem;
  margin: 1.4rem 1rem 1.4rem 1rem;
  @media (max-width: 600px) {
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 2;
  }
`
const StageAndPrizeCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row;
`

const CardContainer = styled.div`
  background-color: ${(props) => props.backgroundColor};
  max-width: 35rem;
  padding-top: 1px;
  padding-bottom: 20px;
  height: fit-content;
  @media (max-width: 600px) {
    width: 100%;
    margin: auto;
    max-width: 100vw;
  }
`
const CardWrapper = styled.div`
  width: 96%;
  border-radius: 4px;
  padding: 16px;
  margin: 30px auto;
  min-height: 26rem;
  box-shadow: 1px 1px 12px 1px ${({ theme }) => theme.colors.text.textMuted16};
  transition: all 0.2s;
  @media (max-width: 600px) {
    background: linear-gradient(
      180deg,
      rgba(240, 241, 245, 0) 0%,
      #f0f1f5 100%
    );
  }
`
const StageCardHeading = styled.div`
  text-transform: uppercase;
  text-align: center;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 0.25rem;
  font-weight: 600;
  color: var(--Text500);
  line-height: 1.8rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
`
const StageTable = styled.table`
  border: 1px solid;
  width: 90%;
  line-height: 36px;
  margin: 1rem auto;
  border-collapse: collapse;

  th,
  td {
    padding: 8px;
    border: 1px solid var(--Text500);
    text-align: left;
  }

  th {
    color: ${({ theme }) => theme.colors.text.text900};
    font-weight: 700;
  }

  td {
    color: var(--Text500);
    font-weight: 600;
    width: 70%;
  }

  tr:first-child th {
    border-top-color: transparent;
  }

  tr:last-child td {
    border-bottom-color: transparent;
  }

  tr:first-child td:last-child {
    color: var(--Punch500);
  }

  tr td:first-child,
  tr th:first-child {
    border-left-color: transparent;
    border-top-color: transparent;
  }

  tr td:last-child,
  tr th:last-child {
    border-top-color: transparent;
    border-right-color: transparent;
  }
`
const StageSubHeading = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  padding-top: 0.8rem;
`
const CardChevronBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 2rem;
  display: block;
  margin: 0.5rem auto;
  color: var(--Text500);
  width: 100%;
  text-align: center;
  -webkit-tap-highlight-color: transparent;

  &.open {
    transform: rotate(180deg);
  }
`
const FlexContainer = styled.div`
  display: flex;
  position: relative;
`
const NotesPoints = styled.div`
  line-height: 26px;
  max-height: 6rem;
  overflow: hidden;
  list-style-position: inside;
  transition: max-height 0.25s ease-out;
  color: var(--Text500);
  line-height: 2;
  font-weight: 500;

  background: linear-gradient(to bottom, var(--Text500), #f8f9fe);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
`

const NotesPoints2 = styled.div`
  line-height: 26px;
  overflow: hidden;
  max-height: 500px;
  list-style-position: inside;
  transition: max-height 0.25s ease-out;
  color: var(--Text500);
  line-height: 2;
  font-weight: 500;

  background: linear-gradient(to bottom, var(--Text500), #f8f9fe);
  -webkit-text-fill-color: var(--Text500);
  -webkit-background-clip: text;
`

const MinWidthSetter = styled.div`
  margin-right: 0.5rem;
`
const VerticalCenterItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const VerticalLeftItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 80%;
  height: 80%;
`
const ParticipationCerticiate = styled.a`
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.35;
  text-align: center;
  ${'' /* display: none; */}
  color: var(--azure-500);
  margin: 0.5rem;
  cursor: pointer;
  @media (max-width: 600px) {
    display: block;
  }
`
const ViewParticipationLogo = styled.img``
const Rank4And5 = styled.div`
  padding: 1rem 1.1rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  border: solid 1px var(--azure-500);
  color: var(--Text500);
  @media (max-width: 600px) {
    min-width: 80%;
  }
`
const Rank123Container = styled.div`
  padding: 1rem 1.1rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  border: solid 1px var(--azure-500);
  color: var(--Text500);
  @media (max-width: 600px) {
    min-width: 80%;
  }
  margin-bottom: 10px;
  width: 85%;
`
const Accordion = styled.div`
  padding: 0.5rem 1.5rem;
`
const AccordionText = styled.p`
  max-height: 0;
  overflow: hidden;
  color: var(--Text500);
  transition: max-height 0.25s ease-out;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.8;
  max-width: 90%;
  font-family: 'Noto Sans';

  &::first-letter {
    text-transform: capitalize;
  }

  @media (max-width: 600px) {
    font-size: 0.8rem;
  }
`
const AccordionBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  text-align: left;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  color: var(--Text700);
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 2;
  display: flex;
  align-items: center;

  div {
    width: 80%;
  }
  &::first-letter {
    text-transform: capitalize;
  }

  &:after {
    content: '+';
    font-size: 22px;
    color: #000000;
    position: relative;
    left: 15%;
  }

  &.open:after {
    content: '-';
  }

  @media (max-width: 600px) {
    font-size: 1rem;
    font-weight: 600;
  }
`
const FlexContianerForStoryPoints = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  @media (max-width: 600px) {
    margin: 2rem auto;
  }
`
const NotesFlexItem = styled.div`
  width: 48%;
  min-width: 10rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 1070px) {
    width: 100%;
  }
  @media (max-width: 600px) {
    width: 96%;
    margin: auto 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 22rem;
    border: 1px var(--Fjord500) solid;
    border-radius: 5px;
    padding: 1rem 2.6rem 2.4rem 2.6rem;
    display: ${(props) => props.display};
  }
`
const BulbLogoContainer = styled.div`
  max-width: 3rem;
  padding-top: 1rem;
  margin: 0 1rem;
  @media (max-width: 600px) {
    margin: auto;
  }
`

const TipsHeading = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--Text700);
  height: auto;
  display: none;
  text-align: center;
  @media (max-width: 600px) {
    display: block;
    margin: 1rem auto;
  }
`
const StoryWritingPoints = styled.p`
  font-size: 1rem;
  font-weight: 500;
  line-height: 2;
  color: var(--Text700);
  margin-bottom: 4rem;
  width: 100%;
  height: auto;
  @media (max-width: 600px) {
    margin: 1rem auto 0.4rem auto;
  }
`
const EarnBannerSection = styled.div`
  background-image: url(${Banner});
  background-color: #cccccc;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding: 3.5rem;
  margin: 1rem auto 3.5rem auto;
  height: 33rem;

  @media (max-width: 600px) {
    height: 18rem;
    padding: 1rem;
  }
`
const EarnWriterMessage = styled.div`
  background-color: #fef9e6;
  border: solid 1px var(--sand-500);
  color: var(--sand-500);
  font-size: 1rem;
  font-weight: 600;
  border: 1px #6b561a solid;
  padding: 0.3rem 1rem;
  border-radius: 0.2rem;
  display: none;
  @media (max-width: 600px) {
    display: block;
  }
`
const EarnHeading = styled.div`
  font-size: 2.6rem;
  font-weight: bold;
  line-height: 1.2;
  color: ${(props) => props.color};
  @media (max-width: 600px) {
    font-size: 2rem;
    font-weight: 800;
  }
`
const EarnSubHeading = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--sand-500);
  @media (max-width: 600px) {
    display: none;
  }
`
const StagePrizeContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`
const Prize2and3Image = styled.img`
  padding-bottom: 2rem;
  max-width: 48%;
  display: inline-block;
`
const DynamicPrize2and3Image = styled.img`
  padding-bottom: 2rem;
  max-width: 96%;
  display: inline-block;
`

const PrizeSubheading = styled.h3`
  background-color: var(--corn-op-32);
  border: 1px var(--azure-500) solid;
  max-width: 22rem;
  font-weight: bold;
  font-size: 20px;
  padding: 0.8rem 2rem;
  margin: 1.2rem 0rem;
  border-radius: 3px;
  text-align: center;
  position: relative;
  color: rgba(13, 21, 54, 0.81);
  line-height: 1.2;

  svg {
    position: absolute;
    top: 0px;
  }
`

const HeadphoneLogo = styled.img`
  position: absolute;
  top: -15%;
`

const BannerButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  @media (max-width: 600px) {
    justify-content: center;
    z-index: 1;
    position: relative;
    width: 72%;
    margin: auto;
    gap: 10px;
  }
`
const Prizelogo = styled.img`
  width: 1.2rem;
  display: inline-block;
  margin-right: 0.3rem;
  transform: translateY(20%);
`
const NotesButtonForMobile = styled.div`
  margin: 16px auto 0px;
  background-color: rgb(62 68 94);
  border-radius: 20px;
  max-width: 160px;
  width: fit-content;
  display: none;
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.text.textMuted16};
  @media (max-width: 600px) {
    display: block;
  }
`
const NoteChangeButton = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: 15px;
  height: 15px;
  transform: scale(${({ isActive }) => (isActive ? 1.4 : 1)});
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
  color: ${({ isActive }) =>
    isActive ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s;
`
const PrizeImg = styled.div`
  background-image: url('./images/stage1.svg');
  width: 100%;
  padding-bottom: 2rem;
  position: relative;
`
const SuspenseNovelsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: 600px) {
    justify-content: space-around;
  }
`
const NovelContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0px 2.6rem;
  @media (max-width: 600px) {
    margin: 0px 0.3rem;
  }
`

const breatheAnimation = keyframes`
  0% {
    transform: translateY(0rem);
  }
  50% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0rem);
  }
`
const ScrollTop = styled.div`
  background-color: #e6e6e6;
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
  text-align: center;
  padding-top: 2rem;
  display: none;
  position: fixed;
  bottom: 3rem;
  right: 10%;
  @media (max-width: 600px) {
    display: block;
  }

  svg {
    animation-name: ${breatheAnimation};
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
`
const FaqSection = styled.section`
  min-height: 18rem;
`

const LiveContainer = styled.div`
  text-align: center;
  color: ${({ color }) => color};
  display: inline;
`
const Dot = styled.div`
  height: 0.6rem;
  width: 0.6rem;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 50%;
  display: inline-block;
`

const DummyCertificateSection = styled.section`
  @media (max-width: 600px) {
    display: none;
  }
`
const DummyCertificateSectionForMobile = styled.section`
  display: none;
  @media (max-width: 600px) {
    display: block;
  }
`
const ExtraPadding = styled.div`
  padding: 1rem 9rem;
  @media (max-width: 600px) {
    padding: 0%;
  }
`
const ExampleNovelImg = styled.img`
  width: 157px;
  height: 237px;
`
const Winner1Text = styled.span`
  position: absolute;
  top: 174px;
  font-size: 16px;
  font-weight: 600;
  right: 75px;
  color: white;
  letter-spacing: 1px;
`
const Winner2Text = styled.span`
  font-size: 14px;
  position: absolute;
  top: 131px;
  right: 222px;
  color: white;
  font-weight: 600;
  letter-spacing: 0.5px;
`
const Winner3Text = styled.span`
  font-size: 14px;
  position: absolute;
  top: 131px;
  left: 210px;
  color: white;
  font-weight: 600;
  letter-spacing: 0.5px;
`

const NumberOfWinners = styled.div`
  position: absolute;
  top: 8px;
  right: 16px;
  color: white;
  font-weight: bold;
`

export {
  NumberOfWinners,
  BannerContainer,
  BannerMobileImg,
  Container,
  BannerHeadingLogo,
  ExampleNovelImg,
  BannerContent,
  BtnContainer,
  EarnBtnContainer,
  BannerButton,
  Button,
  chevronArrowAnimation,
  EarnButton,
  EarnSectionButton,
  BannerHeading,
  BannerHeadingContainer,
  BannerSubHeading,
  SectionsContainer,
  SectionsCommonHeading,
  StageAndPrizeCardContainer,
  CardContainer,
  CardWrapper,
  StageCardHeading,
  StageTable,
  StageSubHeading,
  CardChevronBtn,
  FlexContainer,
  NotesPoints,
  NotesPoints2,
  MinWidthSetter,
  VerticalCenterItems,
  VerticalLeftItems,
  ParticipationCerticiate,
  ViewParticipationLogo,
  Rank4And5,
  Accordion,
  AccordionText,
  AccordionBtn,
  FlexContianerForStoryPoints,
  NotesFlexItem,
  BulbLogoContainer,
  TipsHeading,
  StoryWritingPoints,
  EarnBannerSection,
  EarnWriterMessage,
  EarnHeading,
  EarnSubHeading,
  StagePrizeContainer,
  Prize2and3Image,
  PrizeSubheading,
  BannerButtonContainer,
  Prizelogo,
  NotesButtonForMobile,
  NoteChangeButton,
  PrizeImg,
  SuspenseNovelsContainer,
  NovelContent,
  ScrollTop,
  FaqSection,
  HeadphoneLogo,
  LiveContainer,
  Dot,
  DummyCertificateSection,
  DummyCertificateSectionForMobile,
  ExtraPadding,
  Rank123Container,
  Winner1Text,
  Winner2Text,
  Winner3Text,
  DynamicPrize2and3Image,
}

// Winners Page

export const WinnerTopImg = styled.img`
  width: 100%;
`

export const WinnerH2 = styled.h2`
  font-size: 32px;
  margin: 32px auto 22px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: rgba(13, 21, 54, 0.8);
  @media (max-width: 820px) {
    font-size: 22px;
  }
`
export const Winner_Heading_Title = styled.h2`
  font-size: 1.3rem;
  margin: 32px 1px 22px;
  font-weight: bold;
  line-height: 1.3;
  text-align: center;
  color: rgba(13, 21, 54, 0.8);
  word-spacing: 3px;
  @media (max-width: 820px) {
    font-size: 18px;
  }
`

export const Winner_Sub_Para_Title = styled.h2`
  font-size: 27px;
  width: 85%;
  margin: auto;
  word-spacing: 5px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: rgba(13, 21, 54, 0.8);
  @media (max-width: 820px) {
    font-size: 20px;
  }
`

export const Winner_Stage1 = styled.section`
  display: flex;
  flex-wrap: nowrap;
  justify-content: normal;
  position: relative;
  width: 100%;
  overflow-x: scroll;
  padding-bottom: 12px;
  margin-top: 16px;
`

export const LeftArrow = styled.img`
  width: 35px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0, 90px);
  z-index: 10;
`
export const RightArrow = styled.img`
  width: 35px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0, 90px);
  z-index: 10;
`
export const Stage_Row = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 24px 0;
  @media (max-width: 820px) {
    margin: 0;
  }
`
export const Row_Card = styled.div`
  background-color: #fff6f5;
  display: flex;
  padding: 24px 16px 20px;

  @media (max-width: 820px) {
    flex-basis: unset !important;
    padding: 16px 24px;
    border-radius: 10px;
  }
`
export const WinnerUpperDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 400px;
  margin: 8px 8px 8px 16px;
  flex-grow: 0;
  flex-shrink: 0;
  @media (max-width: 1175px) and (min-width: 820px) {
    max-width: 340px;
    flex-basis: unset !important;
  }
  @media (max-width: 820px) {
    margin: 8px 4px 8px 8px;
    flex-basis: unset !important;
    width: 320px;
  }
`

export const Reward_Note = styled.div`
  background-color: #d4a9a4;
  padding: 8px 16px;
  position: relative;
  margin: 8px 0;
  border: solid 1px #b67e78;
  border-radius: 4px;
`

export const ConfettiImg = styled.img`
  position: absolute;
  top: -12px;
  left: 0;
`

export const Reward_Note_Text = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(13, 21, 54, 0.65);
`

export const Card_Left = styled.div`
  flex: 1;
  @media (max-width: 820px) {
    position: relative;
    padding-top: 15px;
    padding-right: 4px;
  }
`
export const Card_PositionImage = styled.img`
  width: 50px;
  transform: translate(-2px, -8px);
  @media (max-width: 1175px) and (min-width: 820px) {
    width: 40px;
  }
  @media (max-width: 820px) {
    width: 35px;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-27px, -27px);
  }
`
export const Card_AuthorName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: rgba(13, 21, 54, 0.65);
  @media (max-width: 1175px) and (min-width: 820px) {
    font-size: 16px;
  }
  @media (max-width: 820px) {
    font-size: 16px;
    font-weight: 600;
  }
`
export const Card_BookTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #068ae2;
  @media (max-width: 1175px) and (min-width: 820px) {
    font-size: 18px;
  }
  @media (max-width: 820px) {
    font-size: 18px;
    font-weight: 600;
  }
`

export const Card_Reward = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: rgba(13, 21, 54, 0.65);
  @media (max-width: 1175px) and (min-width: 820px) {
    font-size: 20px;
  }
  @media (max-width: 820px) {
    font-size: 18px;
    font-weight: 600;
  }
`

export const Card_Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Card_BookCover = styled.img`
  width: 92px;
  height: 127px;
  flex-grow: 0;
  margin: 0 0 12px 16px;
  border-radius: 4px;
  @media (max-width: 820px) {
    width: 87px;
    height: 127px;
    flex-grow: 0;
    margin: 0 0 8px 0px;
    border-radius: 4px;
  }
`

export const Card_ReadNow = styled.button`
  width: 128px;
  height: 48px;
  margin: 0 0px 0 24px;
  border-radius: 4px;
  background-color: #068ae2;
  font-size: 14px;
  font-weight: bold;
  color: white;
  outline: none;
  border: none;
  cursor: pointer;
  @media (max-width: 820px) {
    margin: 0;
    width: 88px;
    height: 36px;
  }
`
export const Winner_Stage2 = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding-bottom: 12px;
  @media (max-width: 820px) {
    display: flex;
    flex-wrap: nowrap;
    justify-content: normal;
    position: relative;
    width: 100%;
    overflow-x: scroll;
  }
`

export const PrizeDiv = styled.div`
  position: relative;
  padding-right: 18px;
`

export const Prize1Div = styled(PrizeDiv)`
  display: flex;
  align-items: center;
  margin: 35px 0;
  width: 90%;
  height: 97px;
  background: linear-gradient(270deg, #d115f3 19.08%, #3d80f4 78.16%);
  border-radius: 8px;
  gap: 10px;

`
export const Trophy = styled.img`
  position: relative;
  top: -35px;
  width: 40%;
  height: 140px;
`
export const Prize2Div = styled(PrizeDiv)`
  display: flex;
  align-items: center;
  margin: 35px 0;
  width: 90%;
  height: 97px;
  background: linear-gradient(270deg, #efbe10 19.08%, #f4ab3d 78.16%);
  border-radius: 8px;
`
export const Prize3Div = styled(PrizeDiv)`
  display: flex;
  align-items: center;
  margin: 35px 0;
  width: 90%;
  height: 97px;
  background: ${({ linearGradient }) => linearGradient || 'linear-gradient(270deg, #1596F3 19.08%, #3DF491 78.16%)'};
  border-radius: 8px;
`
export const Prize4Div = styled(PrizeDiv)`
  display: flex;
  align-items: center;
  margin: 0 0 10px 0;
  width: 90%;
  background: linear-gradient(270deg, #ab666a 19.08%, #c08868 78.16%);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  padding: 16px 16px 50px 30px;
`
export const RewardAmount = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
  color: white;
  margin: 6px 0;
`
export const AndImg = styled.img`
  margin-right: 8px;
`
export const RewardNote = styled.p`
  font-size: 14px;
  line-height: 135%;
  color: white;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`
export const TrophyBottom = styled.img`
  position: absolute;
  top: 63px;
  left: -5px;
`
export const RewardNoteBottom = styled.img`
  position: absolute;
  bottom: 15px;
  left: -5px;
`
